import { useState, useEffect, useContext } from "react";
import {
  Avatar,
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Upload as UploadAntd,
  message,
  Badge,
} from "antd";
import {
  DownOutlined,
  ExclamationCircleOutlined,
  KeyOutlined,
  LogoutOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import notfound from "../../assets/images/not_found.png";
import { NavLink, useNavigate } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal";
import { Severty, ShowToast } from "../../helper/toast";
import headerLogo from "../../assets/images/teamonelogo.png";
import { AuthContext } from "../../context/AuthContext";
import profilePic from "../../assets/images/favicon.png";
import defaultLogo from "../../assets/images/user-default-iconnn.png";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/lang";
import { uploadViaBackend } from "../../helper/uploadViaBackend";
import Prouser from "../../assets/images/user.png";
import { use } from "react";

const Search = Input.Search;
const { Option } = Select;
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];
function Header({ onPress, setToggle }) {
  const [visible, setVisible] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const { logout } = useContext(AuthContext);
  const [profile, setProfile] = useState({});
  const { request } = useRequest();
  const [selected, setSelected] = useState();
  const [refresh, setRefresh] = useState(false);
  const [commission, setCommission] = useState();
  const [nextPayoutDate, setNextPayoutDate] = useState();
  const [payoutFrequency, setPayoutFrequency] = useState();

  const [desCommission, setDesCommission] = useState();
  const [desNextPayoutDate, setDesNextPayoutDate] = useState();
  const [desPayoutFrequency, setDesPayoutFrequency] = useState();
  // New states for Minimum Amount & Payment Methods
  const [minimumAmount, setMinimumAmount] = useState();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const navigate = useNavigate();
  const { confirm } = Modal;
  const { notification, notificationCount, setRefreshNotification, language } =
    useAppContext();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  useEffect(() => {
    try {
      request({
        url: "/admin/auth/get-profile",
        method: "GET",
        onSuccess: (data) => {
          console.log(data);
          setProfile(data.data);
          setSelected(data.data);
          setCommission(data.data?.vendor_commission || 0);
          setPayoutFrequency(data.data?.payoutFrequency || 0);
          setNextPayoutDate(data.data?.nextPayoutDate || "");

          setDesCommission(data.data?.designer_commission || 0);
          setDesPayoutFrequency(data.data?.desPayoutFrequency || 0);
          setDesNextPayoutDate(data.data?.desNextPayoutDate || "");

          // Set Minimum Amount & Payment Methods
          setMinimumAmount(data.data?.minimum_amount || 0);
          setPaymentMethods(data.data?.paymentMethods || []);
        },
        onError: (error) => {
          console.log(error);
          ShowToast(error?.response?.data?.message || "Internal Server Error", Severty.ERROR);
        },
      });
    } catch (err) {
      console.log(err, "error here")
    }
  }, [refresh]);
  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);
  const items = [
    {
      label: lang("Update") + " " + lang("Profile"),
      key: "1",
      icon: <UserOutlined />,
    },
    {
      label: lang("Change") + " " + lang("Password"),
      key: "2",
      icon: <KeyOutlined />,
    },
    {
      label: lang("Logout"),
      key: "3",
      icon: <LogoutOutlined />,
    },
  ];
  const [notificationReadCount, setNotificationReadCount] = useState(0);
  const fetchNotificationCount = async () => {
    try {
      request({
        url: "/admin/auth/notification/count",
        method: "GET",
        onSuccess: (data) => {
          setNotificationReadCount(data?.data?.notificationReadCount);
          console.log("notificationReadCount", data?.count);
        },
        onError: (error) => {
          console.error("Error fetching notification count:", error);
        },
      });
    } catch (error) {
      console.error("Error fetching notification count:", error);
    }
  };

  useEffect(() => {
    // fetchNotificationCount();
  }, []);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };
  const showConfirm = () => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to logout?</Button>,
        onOk() {
          logout();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };
  const { name } = JSON.parse(localStorage.getItem("userProfile")) || {};
  console.log("notificationReadCount", notificationReadCount);
  console.log("notification", notificationCount);

  const notificationitems = [
    {
      label: (
        <div className="notification_top">
          <div className="notification-head">
            <h5>{lang("Notifications")}</h5>
          </div>
          <div className="notification-inner">
            {notification?.length ? (
              notification?.map((item) => (
                <div
                  key={item._id}
                  className="single-notification"
                // onClick={() => handleNotiNavigate(item)}
                >
                  <div className="notification-img">
                    <img
                      src={item?.from_id.image ? item?.from_id.image : Prouser}
                    />
                  </div>
                  <div className="notification-cont">
                    {/* <p>
                  <span>Vendor Heeba Khan</span> attach a deposit receipt to the
                  App bank account of <span>AED 100.00</span>
                </p> */}
                    <p>
                      <span>{item.title ? item.title : ""}</span>
                      <p>{item.description ? item.description : ""}</p>
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <span>{lang("No Notification")}</span>
            )}
          </div>
          {notification?.length ? (
            <div className="viewAll_notification">
              <Button
                onClick={() => navigate("/notification")}
                className="btnStyle btn_primary"
              >
                {lang("View All")}
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];
  const handleMenuClick = (e) => {
    switch (e.key) {
      case "1":
        setProfileVisible(true);
        break;
      case "2":
        setVisible(true);
        break;
      case "3":
        showConfirm();
        break;

      case "4":
        setAppSettingVisible(true);
        break;
      default:
        break;
    }
  };


  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  return (
    <>
      <Row gutter={[24, 0]} className="align-items-center">
        {/* Left Side: Logo & Toggle */}
        <Col span={24} xs={18} md={12} xl={12} lg={12}>
          <div className="toggale-headr d-flex align-items-center ">
            <Button
              type="link"
              className="sidebar-toggler ps-0 d-none d-lg-block"
              onClick={() => setToggle()}
            >
              {toggler}
            </Button>

            <div className="tabLogo">
              {/* Replace with actual image if needed */}
              <img
                className="mian-new-header-logo d-block d-sm-none"
                src={headerLogo}
                alt="Logo"
              />
              <h2
                style={{ fontWeight: "600" }}
                className="main-center-logo-2 d-none d-sm-block"
              >
                TEAM INTELLIGENCE HUB
              </h2>
            </div>
          </div>
        </Col>

        {/* Right Side: Notification & Toggler */}
        <Col
          span={24}
          xs={6}
          md={12}
          xl={12}
          lg={12}
          className="header-control d-flex justify-content-end align-items-center gap-3"
        >
          <div className="profileDropdownMain">
            <Dropdown menu={menuProps}>
              <Button className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open">
                <div className=" d-flex align-items-center gap-2">

                  <div className="d-none d-xl-block">
                    <div className="userName">{selected?.name}</div>
                    <div className="userEmail">{selected?.email}</div>
                  </div>
                  <div className="userImg">
                    <Image
                      src={selected?.profilePic}
                      // src={profile}
                      preview={false}
                    />
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div>
          {/* Notification Button */}
          {/* <div className="notificationDropdownMain">
            <Button
              onClick={() => navigate("/notification")}
              style={{ position: "relative" }}
            >
              <Badge
                count={notificationReadCount}
                size="small"
                offset={[-5, 5]}
              >
                <img
                  src={Notification}
                  alt="Notification Icon"
                  style={{ width: "18px", height: "18px" }}
                />
              </Badge>
            </Button>
          </div> */}
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
        </Col>
      </Row>

      {isLogoutModalVisible && (
        <DeleteModal
          title="Logout"
          subtitle="Are you sure you want to logout?"
          show={isLogoutModalVisible}
          hide={() => setIsLogoutModalVisible(false)}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            logout();
          }}
        />
      )}

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => setProfileVisible(false)}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          hide={() => setVisible(false)}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);

  const beforeUpload = (file) => {
    // console.log(file.type, "file type>>>>>>.")
    // if (fileType.includes(file.type)) {

    // } else {
    //   message.error("File format is not correct")
    //   return false
    // }
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      // ShowToast.error(`Image must be smaller than 5 MB!`)
      return false;
    }
    return true;
  };

  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChange = async (event) => {
    const { file } = event;

    let validateImage =
      file.type.includes("image") && !file.type.includes("svg") && !file.type.includes("gif");

    if (!validateImage) {
      return ShowToast("Media not supported " + file.type, Severty.ERROR);
    }

    const isValidSize = beforeUpload(file);
    if (!isValidSize) {
      return ShowToast("Image must be smaller than 5 MB!", Severty.ERROR);
    }

    setFile([{ uid: file.uid, name: file.name, status: "uploading" }]); // ✅ Ensure `uid` exists

    try {
      const uploadResponse = await uploadFileToS3(file, "invent-colab-obj-bucket");

      if (!uploadResponse || !uploadResponse.Location) {
        throw new Error("Upload failed");
      }

      setFile([
        {
          uid: file.uid, // ✅ Ensure `uid` exists
          name: file.name,
          status: "done",
          url: uploadResponse.Location, // ✅ Correct file URL
          thumbUrl: uploadResponse.Location, // ✅ Ensure preview works
        },
      ]);

      console.log(uploadResponse);
    } catch (err) {
      console.error(err);
      setFile([]); // ✅ Reset file if upload fails
    }
  };

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({ ...data });

    if (data.profilePic) {
      setFile([
        {
          uid: "1", // ✅ Ensure `uid` exists
          name: "profile.jpg",
          status: "done",
          url: data.profilePic,
          thumbUrl: data.profilePic,
        },
      ]);
    } else {
      setFile([]);
    }
  }, [data]);
  const onEditProfile = (values) => {
    const { email, name } = values;
    if (file.length <= 0)
      return ShowToast("Please select the profile Image ", Severty.ERROR);
    const payload = {};
    setLoading(true);
    payload.email = email;
    payload.name = name;
    payload.profilePic = file.length > 0 ? file[0].url : null;
    request({
      url: "/admin/auth/update-profile",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
    });
  };
  return (
    <Modal
      visible={show}
      title={`${data ? "Edit Profile" : ""}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please input the name!" },
                {
                  validator: (_, value) => {
                    if (value && value.trim() === "") {
                      return Promise.reject("Name cannot be only spaces");
                    }
                    return Promise.resolve();
                  },
                },
                {
                  pattern: /^[\p{L}\p{M}\s\-]*$/u,
                  message: "Only letters, spaces, and hyphen (-) allowed (e.g. JEAN-FRANCOIS)",
                },
                {
                  max: 50,
                  message: "Name cannot exceed 50 characters",
                },
              ]}
            >
              <Input placeholder="Name" />
            </Form.Item>

          </Col>
          <Col span={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                { required: true, message: "Please input the email!" },
                {
                  max: 100,
                  message: "Email cannot exceed 100 characters",
                },
              ]}
            >
              <Input placeholder={"Email"} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <UploadAntd
              listType="picture"
              maxCount={1}
              customRequest={handleChange}
              // onChange={handleChange}
              onRemove={() => setFile([])} // ✅ Ensure file state resets
              fileList={file} // ✅ Ensure it always contains valid objects
            >
              {file.length > 0 ? null : <Button icon={<UploadOutlined />}>Upload</Button>}
            </UploadAntd>
            <p className="main-new-upload-graph-name-insturction">
              **You can select only ( .png, .jpg) format files upto 5 MB
              file size..!!!
            </p>
          </Col>
        </Row>

        {/* <Form.Item name="description" label="Description">
            <Input type="textarea" />
          </Form.Item> */}

        {/* <Form.Item name="type" label="Type">
            <Radio.Group>
              <Radio value="public">Public</Radio>
              
              <Radio value="private">Private</Radio>
            </Radio.Group>
          </Form.Item> */}
      </Form>
    </Modal>
  );
};


const ChangePassword = ({ show, hide }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const { logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleCreate = (values) => {
    console.log(values, "values");
    const { old_password, new_password } = values;
    const payload = {};
    if (!old_password || !new_password)
      return ShowToast("Please enter password ", Severty.ERROR);
    setLoading(true);
    payload.new_password = new_password;
    payload.old_password = old_password;
    request({
      url: "/admin/auth/change-password",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          logout();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      title="Change password"
      okText="Ok"
      onCancel={() => {
        hide();
        form.resetFields();
      }}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form
        id="create"
        form={form}
        layout="vertical"
        onFinish={handleCreate}
        className="change-pw"
        disabled={loading}
      >
        <Form.Item
          label="Old Password"
          name="old_password"
          hasFeedback
          rules={[
            { required: true, message: "Please input the old password!" },
            {
              validator: (_, value) =>
                value && value.trim()
                  ? Promise.resolve()
                  : Promise.reject(new Error("Password cannot be only spaces!")),
            },
          ]}
        >
          <Input.Password maxLength={50} placeholder="Old Password" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          hasFeedback
          rules={[
            { required: true, message: "Please input the new password!" },
            {
              min: 8,
              message: "Password must be at least 8 characters long!",
            },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/,
              message:
                "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character!",
            },
            {
              max: 100,
              message: "Password cannot exceed 100 characters",
            },
          ]}
        >
          <Input.Password maxLength={50} placeholder="New Password" />
        </Form.Item>

        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please input the confirm password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Passwords that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password maxLength={50} placeholder={"Confirm New Password"} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Header;
